const VALID = "VALID";
const INVALID = "INVALID";
const EXPIRED = "EXPIRED";
const SETUP = "SETUP";
const REVOKED = "REVOKED";

export const AuthDataStatus = {
    VALID,
    INVALID,
    EXPIRED,
    SETUP,
    REVOKED,
};
